import React from 'react';
import { Grid, TextField, Autocomplete, Typography, Box, Chip } from '@mui/material';
import { findingsSuggestions, operationNoteSuggestions } from '../../constants/options';

const FindingsNotesSection = ({ formData, handleChange, setFormData }) => {
  const addSuggestion = (field, text) => {
    setFormData((prev) => ({
      ...prev,
      [field]: prev[field] ? prev[field] + " " + text : text,
    }));
  };

  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6" sx={{ color: '#008080', mb: 2, fontWeight: 'bold' }}>
        Step 4: Intra-Op Findings & Operation Notes
      </Typography>
      
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Box sx={{ mb: 1, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            <Typography variant="caption" sx={{ mt: 1 }}>Suggestions:</Typography>
            {findingsSuggestions.map(s => (
                <Chip key={s} label={s} size="small" onClick={() => addSuggestion('findings', s)} sx={{ cursor: 'pointer' }} />
            ))}
          </Box>
          <TextField
            label="Intra-Operative Findings"
            multiline
            rows={4}
            fullWidth
            name="findings"
            value={formData.findings || ''}
            onChange={handleChange}
            variant="outlined"
            placeholder="Describe intra-operative findings..."
          />
        </Grid>
        
        <Grid item xs={12}>
          <Box sx={{ mb: 1, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            <Typography variant="caption" sx={{ mt: 1 }}>Suggestions:</Typography>
            {operationNoteSuggestions.map(s => (
                <Chip key={s} label={s} size="small" onClick={() => addSuggestion('operation_notes', s)} sx={{ cursor: 'pointer' }} />
            ))}
          </Box>
          <TextField
            label="Operation Notes"
            multiline
            rows={5}
            fullWidth
            name="operation_notes"
            value={formData.operation_notes || ''}
            onChange={handleChange}
            variant="outlined"
            placeholder="Detailed procedure steps..."
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FindingsNotesSection;
